//icons
import TrashIcon from '@/assets/icons/trash.svg';

export const greyUploadImageStyle = {
	wrapper: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
		textAlign: 'center',
		// borderRadius: 'var(--default--border-radius)',
		backgroundColor: 'var(--neutral-100)',
	} as any,

	uploadedHover: {
		'&:hover:before': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			background: 'rgba(0, 0, 0, 0.60)',
			borderRadius: 'var(--default--border-radius)',
			backgroundImage: `url(${TrashIcon})`,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			cursor: 'pointer',
		},
	},

	image: {
		overflow: 'hidden',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		'& img': {
			objectFit: 'contain',
			height: '100%',
			width: 'auto',
		},
	},

	button: {
		padding: '0 4px',
		textTransform: 'none',
		fontWeight: 400,
		fontSize: '14px',
		height: '18px',
	},

	dragged: {
		outline: '1px solid var(--neutral-200)',
	},

	error: {
		opacity: 1,
		backgroundColor: '1px solid var(--error-500)',
		border: '1px solid var(--error-500)',

		'& .MuiButtonBase-root .MuiButton-endIcon svg path': {
			fill: 'var(--error-400)',
		},
	},

	disabled: {
		backgroundColor: 'var(--neutral-50)',

		'& .MuiButtonBase-root .MuiButton-endIcon svg path': {
			fill: 'var(--neutral-200)',
		},
	},
};
